module.exports = __webpack_public_path__ + "static/media/button-start.4b8553fb.png";